import React from 'react';
import { useParams } from 'react-router-dom';
import classes from './PresentationPdf.module.scss';

export default function PresentationPdf() {
    let { product } = useParams();

    let title;
    let iframe;
    let id;
    switch (product) {
        case 'presentation-en':
            title = 'AIDA Presentation (EN)';
            id = '1hKJChgcLH5V5LKBdDd2Ete7xVxwA9Uy3lt96l_d2i7E';
            iframe = <iframe
                src={`https://docs.google.com/presentation/d/${id}/embed?start=false&loop=false&delayms=3000`}
                frameBorder="0" width="1440" height="839" allowFullScreen="true" mozallowfullscreen="true"
                webkitallowfullscreen="true" title={title}></iframe>;
            break;
        case 'presentation-fr':
            title = 'Présentation AIDA (FR)';
            id = '1kReWv9b9X-obrOaBYMBB7GyKCtBxqCQGy8XmUUFPVzE';
            iframe = <iframe
                src={`https://docs.google.com/presentation/d/${id}/embed?start=false&loop=false&delayms=3000`}
                frameBorder="0" width="1440" height="839" allowFullScreen="true" mozallowfullscreen="true"
                webkitallowfullscreen="true" title={title}></iframe>;
            break;
        case 'presentation-it':
            title = 'Presentazione AIDA (IT)';
            id = '1NA4cTkbQsSOEp5Mg1rZc4SLF_VkD8fYEwF28V9dAVRg';
            iframe = <iframe
                src={`https://docs.google.com/presentation/d/${id}/embed?start=false&loop=false&delayms=3000`}
                frameBorder="0" width="1440" height="839" allowFullScreen="true" mozallowfullscreen="true"
                webkitallowfullscreen="true" title={title}></iframe>;
            break;
        case 'case-studies-en':
            title = 'AIDA Case Studies (EN)';
            id = '1t_8COA9-8eZHucm5Ke61hqoP5_cXDjfQi-sTCsJ46GU';
            iframe = <iframe
                src={`https://docs.google.com/presentation/d/${id}/embed?start=false&loop=false&delayms=3000`}
                frameBorder="0" width="1440" height="839" allowFullScreen="true" mozallowfullscreen="true"
                webkitallowfullscreen="true" title={title}></iframe>;
            break;
        case 'case-studies-fr':
            title = 'Études de cas AIDA (FR)';
            id = '1McbJeqoqRM2Yktd9AnsOajj0EjVXorPxTkYm9gxclPI';
            iframe = <iframe
                src={`https://docs.google.com/presentation/d/${id}/embed?start=false&loop=false&delayms=3000`}
                frameBorder="0" width="1440" height="839" allowFullScreen="true" mozallowfullscreen="true"
                webkitallowfullscreen="true" title={title}></iframe>;
            break;
        case 'case-studies-it':
            title = 'Casi studio AIDA (IT)';
            id = '1mofhrm_cf-9knLjW6OA-T5LuQwRUGexJbGREEhq6dIk';
            iframe = <iframe
                src={`https://docs.google.com/presentation/d/${id}/embed?start=false&loop=false&delayms=3000`}
                frameBorder="0" width="1440" height="839" allowFullScreen="true" mozallowfullscreen="true"
                webkitallowfullscreen="true" title={title}></iframe>;
            break;
        default:
            break;
    }

    return iframe ? <div className={classes.PresentationPdf}>
        <h1>{title}</h1>
        <div>
            {iframe}
            {id && <div className={classes.Link}><a href={`https://docs.google.com/presentation/d/${id}/export/pdf`}
                                                    target="_blank" rel="noopener noreferrer">Download the presentation
                                                                                              as PDF</a></div>}
        </div>
    </div> : <p>Nothing here...</p>;
};
